import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../page/index.vue'),
    // redirect:'/home'
  },
	{
	  path: '/home',
	  component: () => import('../page/home/home.vue'),
	  meta: {title: '首页'}
	},
  {
    path: '/CK',
    component: () => import('../page/CK/index.vue'),
    meta: {title: '详情'}
  },
  {
    path: '/WU',
    component: () => import('../page/wu.vue'),
  },
];

// 为路由对象，添加beforeEach  导航守卫
// router.beforeEach((to,from,next) => {
// 	//用户访问的登录页，直接放行 后续可加上其他页面
// 	if (to.path === '/login') {
// 		next()
// 	}else{
// 	//获取保存的token值
// 	const toKenStr = token值
// 	// 判断有没有token值 有直接放行 没有跳转到登录页面
// 	if (!toKenStr) {
// 		next('/login')
// 	}else{
// 		next()
// 	}
// })
//}

const router = new VueRouter({
	linkActiveClass:'selected',
	routes,
	mode: 'history',
})
export default router












//第二种方式
// export default new Router({
//   mode: 'history',
//   routes: [
//     {
//       path: '',
//       name: 'index',
//       component: index,
//       redirect: '/',
//       children: [
//         {
//           path: '/',
//           component: () => import('../components/page/home/home.vue'),
//           meta: {
//             title: '首页'
//           }
//         }
//       ]
//     },
// 	// 登录
// 	{
// 	  path: '/login',
// 	  name: 'login',
// 	  component: login,
// 	  meta: {
// 		  title: '登录'
// 	  }
// 	},
// 	//注册
// 	{
// 	  path: '/registered',
// 	  name: 'registered',
// 	  component: registered,
// 	  meta: {
// 		  title: '注册'
// 	  }
// 	}
//   ],
//   // 动态路由
// })



// WEBPACK FOOTER //
// ./src/router/index.js